var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEsgArrowRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 7,
    viewBox: "0 0 14 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.210118 6.49228C0.497638 6.79045 0.972433 6.79908 1.2706 6.51156L5.27159 2.65347C5.67043 2.26887 5.93803 2.01161 6.16019 1.8294C6.37538 1.6529 6.49942 1.58862 6.59461 1.55846C6.84033 1.48059 7.10412 1.48059 7.34984 1.55846C7.44502 1.58862 7.56906 1.6529 7.78426 1.8294C8.00641 2.01161 8.27401 2.26887 8.67286 2.65347L12.6738 6.51156C12.972 6.79908 13.4468 6.79045 13.7343 6.49228C14.0218 6.19411 14.0132 5.71932 13.715 5.4318L9.71406 1.5737L9.6926 1.553C9.32076 1.19443 9.00988 0.894643 8.73551 0.669608C8.44892 0.434544 8.15453 0.239949 7.80298 0.128541C7.26239 -0.0427709 6.68206 -0.0427709 6.14147 0.128541C5.78991 0.239949 5.49553 0.434544 5.20894 0.669607C4.93456 0.894646 4.62368 1.19444 4.25183 1.55302L4.23039 1.5737L0.229399 5.4318C-0.0687702 5.71932 -0.0774028 6.19411 0.210118 6.49228Z",
    fill: "#054254"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsgArrowRight);
export default __webpack_public_path__ + "static/media/EsgArrowRight.7f371e9071f67c386ee94657b1c3fb9b.svg";
export { ForwardRef as ReactComponent };